import React, { useEffect, useState } from 'react';
import { Select } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { useStyles, StyledMenuItem } from './EquipmentDropdownStyles';
import { setSelectedEquipments } from "../../../store/euqipmentFiltersSlice";
import { useDispatch } from "react-redux";

const EquipmentDropdown = ({
   type = 'equipment',
   options,
   selectedEquipment = [],
   handleSelectionChange = (val) => {},
   borderColor = '#000000',
   iconColor = '#000000',
   textColor = '#000000',
   width = '200px',
   placeholder = '',
   disabled = false,
 }) => {
  const dispatch = useDispatch();
  const selectStyles = useStyles.select(borderColor, textColor, width);
  const menuPropsStyles = useStyles.menuProps(borderColor);
  const startAdornmentStyles = useStyles.startAdornment(textColor);
  const [selectedIntEquipment, setSelectedIntEquipment] = useState([]);

  const getEquipmentNames = (selectedIds) => {
    return selectedIds.map(id => {
      const equipment = options.find(eq => eq.id === id);
      return equipment ? equipment.name : '';
    }).join(', ');
  };

  const getPlaceholder = () => {
    if (placeholder) {
      return placeholder;
    } else {
      return type === 'equipment' ? 'Select equipment' : 'Select tags';
    }
  };

  const handleClickedEquipment = (id) => {
    handleSelectionChange(id);

    if (selectedIntEquipment?.includes(id)) {
      const result = selectedIntEquipment.filter(e => e !== id);
      setSelectedIntEquipment(result);

      if (type === 'default') {
        return;
      }

      dispatch(setSelectedEquipments({ type: type === 'equipment' ? 'equipment' : 'tag', value: id }));
    } else {
      const result = [...selectedIntEquipment, id];
      setSelectedIntEquipment(result);

      if (type === 'default') {
        return;
      }

      dispatch(setSelectedEquipments({ type: type === 'equipment' ? 'equipment' : 'tag', value: id }));
    }
  };

  return (
    <Select
      displayEmpty
      variant="outlined"
      value={selectedEquipment}
      onChange={(event) => {
        const value = event.target.value;
        handleClickedEquipment(value);
      }}
      multiple
      renderValue={(selected) => {
        if (selected.length === 0) {
          return <span style={startAdornmentStyles}>{getPlaceholder()}</span>;
        } else {
          return getEquipmentNames(selected);
        }
      }}
      sx={selectStyles}
      MenuProps={{
        sx: menuPropsStyles,
        variant: 'menu',
      }}
      disabled={disabled}
    >
      {options.map((equipment) => (
        <StyledMenuItem
          key={equipment.id}
          value={equipment.id}
          isSelected={selectedEquipment?.includes(equipment.id)}
          iconColor={iconColor}
        >
          <span style={{ color: textColor, fontSize: '14px' }}>{equipment.name}</span>
          {selectedEquipment?.includes(equipment.id) ? (
            <StarIcon sx={{ marginLeft: '5px', color: iconColor }} />
          ) : (
            <StarBorderIcon sx={{ marginLeft: '10px', color: `${iconColor}!important` }} />
          )}
        </StyledMenuItem>
      ))}
    </Select>
  );
};

export default EquipmentDropdown;